export const PAGE_VIEWS_FILMS = 'films';
export const PAGE_VIEWS_SCREEN = 'screen';

export const PAGE_VIEWS = [PAGE_VIEWS_FILMS, PAGE_VIEWS_SCREEN];
